"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GumballTransform_gumballTransformControls, _GumballTransform_systemInfo, _GumballTransform_transformationToolsPlaceholder, _GumballTransform_currentMatrix, _GumballTransform_enableRotation, _GumballTransform_enableScaling, _GumballTransform_enableTranslation, _GumballTransform_moving, _GumballTransform_pivotDragging, _GumballTransform_scale, _GumballTransform_space;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GumballTransform = void 0;
const THREE = __importStar(require("three"));
const viewer_1 = require("@shapediver/viewer");
const gl_matrix_1 = require("gl-matrix");
const TransformationToolsManager_1 = require("../TransformationToolsManager");
const GumballTransformControls_1 = require("./three/GumballTransformControls");
/* eslint-disable @typescript-eslint/no-unused-vars */
class GumballTransform extends TransformationToolsManager_1.TransformationToolsManager {
    constructor(viewport, nodes, settings, id) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16;
        super(id, viewport, nodes, settings);
        _GumballTransform_gumballTransformControls.set(this, void 0);
        _GumballTransform_systemInfo.set(this, viewer_1.SystemInfo.instance);
        _GumballTransform_transformationToolsPlaceholder.set(this, new THREE.Object3D());
        _GumballTransform_currentMatrix.set(this, new THREE.Matrix4());
        _GumballTransform_enableRotation.set(this, true);
        _GumballTransform_enableScaling.set(this, true);
        _GumballTransform_enableTranslation.set(this, true);
        _GumballTransform_moving.set(this, false);
        _GumballTransform_pivotDragging.set(this, false);
        _GumballTransform_scale.set(this, 0.15);
        _GumballTransform_space.set(this, "local");
        __classPrivateFieldSet(this, _GumballTransform_gumballTransformControls, new GumballTransformControls_1.GumballTransformControls(viewport.threeJsCoreObjects.camera, viewport.threeJsCoreObjects.renderer.domElement, this.restrictionManager, this.updateObjectsInternal.bind(this), this.updateObjectMatricesInternal.bind(this)), "f");
        const isMobile = __classPrivateFieldGet(this, _GumballTransform_systemInfo, "f").isMobile;
        const mobileFactor = isMobile ? 2 : 1;
        __classPrivateFieldSet(this, _GumballTransform_scale, ((_a = settings === null || settings === void 0 ? void 0 : settings.scale) !== null && _a !== void 0 ? _a : 0.15) * mobileFactor, "f");
        // we don't allow to change the space for now
        __classPrivateFieldSet(this, _GumballTransform_space, (_b = settings === null || settings === void 0 ? void 0 : settings.space) !== null && _b !== void 0 ? _b : "local", "f");
        this.enableRotation = (_c = settings === null || settings === void 0 ? void 0 : settings.enableRotation) !== null && _c !== void 0 ? _c : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationX =
            (_e = (_d = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _d === void 0 ? void 0 : _d.x) !== null && _e !== void 0 ? _e : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationY =
            (_g = (_f = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _f === void 0 ? void 0 : _f.y) !== null && _g !== void 0 ? _g : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationZ =
            (_j = (_h = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _h === void 0 ? void 0 : _h.z) !== null && _j !== void 0 ? _j : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationXY =
            ((_k = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _k === void 0 ? void 0 : _k.xy) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationY
                : (_l = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _l === void 0 ? void 0 : _l.xy;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationYZ =
            ((_m = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _m === void 0 ? void 0 : _m.yz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationY &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationZ
                : (_o = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _o === void 0 ? void 0 : _o.yz;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationXZ =
            ((_p = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _p === void 0 ? void 0 : _p.xz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotationZ
                : (_q = settings === null || settings === void 0 ? void 0 : settings.enableRotationAxes) === null || _q === void 0 ? void 0 : _q.xz;
        this.enableScaling = (_r = settings === null || settings === void 0 ? void 0 : settings.enableScaling) !== null && _r !== void 0 ? _r : false;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingX =
            (_t = (_s = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _s === void 0 ? void 0 : _s.x) !== null && _t !== void 0 ? _t : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingY =
            (_v = (_u = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _u === void 0 ? void 0 : _u.y) !== null && _v !== void 0 ? _v : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingZ =
            (_x = (_w = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _w === void 0 ? void 0 : _w.z) !== null && _x !== void 0 ? _x : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingXY =
            ((_y = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _y === void 0 ? void 0 : _y.xy) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingY
                : (_z = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _z === void 0 ? void 0 : _z.xy;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingYZ =
            ((_0 = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _0 === void 0 ? void 0 : _0.yz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingY &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingZ
                : (_1 = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _1 === void 0 ? void 0 : _1.yz;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingXZ =
            ((_2 = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _2 === void 0 ? void 0 : _2.xz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScalingZ
                : (_3 = settings === null || settings === void 0 ? void 0 : settings.enableScalingAxes) === null || _3 === void 0 ? void 0 : _3.xz;
        this.enableTranslation = (_4 = settings === null || settings === void 0 ? void 0 : settings.enableTranslation) !== null && _4 !== void 0 ? _4 : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationX =
            (_6 = (_5 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _5 === void 0 ? void 0 : _5.x) !== null && _6 !== void 0 ? _6 : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationY =
            (_8 = (_7 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _7 === void 0 ? void 0 : _7.y) !== null && _8 !== void 0 ? _8 : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationZ =
            (_10 = (_9 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _9 === void 0 ? void 0 : _9.z) !== null && _10 !== void 0 ? _10 : true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationXY =
            ((_11 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _11 === void 0 ? void 0 : _11.xy) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationY
                : (_12 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _12 === void 0 ? void 0 : _12.xy;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationYZ =
            ((_13 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _13 === void 0 ? void 0 : _13.yz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationY &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationZ
                : (_14 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _14 === void 0 ? void 0 : _14.yz;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationXZ =
            ((_15 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _15 === void 0 ? void 0 : _15.xz) === undefined
                ? __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationX &&
                    __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslationZ
                : (_16 = settings === null || settings === void 0 ? void 0 : settings.enableTranslationAxes) === null || _16 === void 0 ? void 0 : _16.xz;
        this.setup();
    }
    get enableRotation() {
        return __classPrivateFieldGet(this, _GumballTransform_enableRotation, "f");
    }
    set enableRotation(value) {
        __classPrivateFieldSet(this, _GumballTransform_enableRotation, value, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotation = value;
    }
    get enableScaling() {
        return __classPrivateFieldGet(this, _GumballTransform_enableScaling, "f");
    }
    set enableScaling(value) {
        __classPrivateFieldSet(this, _GumballTransform_enableScaling, value, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScaling = value;
    }
    get enableTranslation() {
        return __classPrivateFieldGet(this, _GumballTransform_enableTranslation, "f");
    }
    set enableTranslation(value) {
        __classPrivateFieldSet(this, _GumballTransform_enableTranslation, value, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslation = value;
    }
    get scale() {
        return __classPrivateFieldGet(this, _GumballTransform_scale, "f");
    }
    get space() {
        return __classPrivateFieldGet(this, _GumballTransform_space, "f");
    }
    get transformationToolsPlaceholderMatrix() {
        return gl_matrix_1.mat4.fromValues(...__classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f").matrix.toArray());
    }
    get type() {
        return "gumball";
    }
    closeLogic() {
        this.parentObject.remove(__classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f"));
        this.parentObject.remove(__classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f"));
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").detach();
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").dispose();
        this.viewport.threeJsCoreObjects.scene.remove(this.parentObject);
    }
    onKeyDownLogic(event, pointerInCanvas) {
        if (this.closed)
            return;
        if (!pointerInCanvas)
            return;
        this.keysPressed[event.key] = true;
        if (__classPrivateFieldGet(this, _GumballTransform_moving, "f") === false &&
            Object.values(this.keysPressed).length === 1 &&
            this.keyPressed("p") &&
            __classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === false) {
            this.activatePivotDragging();
        }
    }
    onKeyUpLogic(event, pointerInCanvas) {
        if (this.closed)
            return;
        delete this.keysPressed[event.key];
        if (__classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === true && !this.keyPressed("p")) {
            this.deactivatePivotDragging();
        }
    }
    onMouseWheel(event) { }
    onPointerDownLogic(event) {
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").onPointerDown(event);
        __classPrivateFieldSet(this, _GumballTransform_moving, __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").dragging, "f");
        if (__classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").dragging ||
            __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").hovering)
            this.viewport.addRestrictedCanvasListenerToken(this.canvasEventListenerToken);
    }
    onPointerEndLogic(event) {
        __classPrivateFieldSet(this, _GumballTransform_moving, false, "f");
        this.viewport.removeRestrictedCanvasListenerToken(this.canvasEventListenerToken);
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").onPointerUp(event);
    }
    onPointerMoveLogic(event) {
        if (__classPrivateFieldGet(this, _GumballTransform_moving, "f") === false &&
            Object.values(this.keysPressed).length === 1 &&
            this.keyPressed("p") &&
            __classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === false) {
            this.activatePivotDragging();
        }
        if (__classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === true && !this.keyPressed("p")) {
            this.deactivatePivotDragging();
        }
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").onPointerHover(event);
        if (__classPrivateFieldGet(this, _GumballTransform_moving, "f"))
            __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").onPointerMove(event);
        if (__classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").dragging ||
            __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").hovering) {
            this.viewport.addRestrictedCanvasListenerToken(this.canvasEventListenerToken);
        }
        else {
            this.viewport.removeRestrictedCanvasListenerToken(this.canvasEventListenerToken);
        }
    }
    onPointerOutLogic(event) {
        __classPrivateFieldSet(this, _GumballTransform_moving, false, "f");
    }
    onPointerUpLogic(event) {
        __classPrivateFieldSet(this, _GumballTransform_moving, false, "f");
    }
    activatePivotDragging() {
        __classPrivateFieldSet(this, _GumballTransform_pivotDragging, true, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").pivotDragged = true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslation = true;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotation = false;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScaling = false;
        if (this.singleNode === true && this.reuseTransformation === true) {
            const index = this.nodes[0].transformations.findIndex((t) => t.id === "SD_transformation_tools_matrix");
            if (index !== -1) {
                this.previousTransformationToolsMatrix[0] = gl_matrix_1.mat4.clone(this.nodes[0].transformations[index].matrix);
            }
            else {
                this.previousTransformationToolsMatrix[0] = gl_matrix_1.mat4.create();
            }
        }
        __classPrivateFieldSet(this, _GumballTransform_currentMatrix, __classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f").matrix
            .clone()
            .multiply(new THREE.Matrix4().fromArray(this.pivotOffset).invert()), "f");
    }
    deactivatePivotDragging() {
        __classPrivateFieldSet(this, _GumballTransform_pivotDragging, false, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").pivotDragged = false;
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableTranslation =
            __classPrivateFieldGet(this, _GumballTransform_enableTranslation, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableRotation =
            __classPrivateFieldGet(this, _GumballTransform_enableRotation, "f");
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").gizmo.enableScaling =
            __classPrivateFieldGet(this, _GumballTransform_enableScaling, "f");
    }
    setup() {
        const matrix = this.initialize();
        __classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f").applyMatrix4(new THREE.Matrix4().fromArray(matrix));
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").attach(__classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f"));
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").setSize(this.scale);
        this.parentObject.add(__classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f"));
        this.parentObject.add(__classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f"));
        this.parentObject.traverse((obj) => (obj.userData.ignoreInRayTracingTest = true));
        this.viewport.threeJsCoreObjects.scene.add(this.parentObject);
        this.captureInitialWorldMatrices();
        // we register the CAMERA_FREEZE whenever the dragging happens
        __classPrivateFieldGet(this, _GumballTransform_gumballTransformControls, "f").addEventListener("dragging-changed", (event) => this.toggleCameraFreeze(event.value));
    }
    updateObjectMatricesInternal() {
        if (__classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === true) {
            const currentMatrix = __classPrivateFieldGet(this, _GumballTransform_transformationToolsPlaceholder, "f").matrix
                .clone()
                .multiply(new THREE.Matrix4().fromArray(this.pivotOffset).invert());
            const delta = new THREE.Matrix4().multiplyMatrices(__classPrivateFieldGet(this, _GumballTransform_currentMatrix, "f").clone().invert(), currentMatrix);
            gl_matrix_1.mat4.multiply(this.pivotOffset, this.pivotOffset, gl_matrix_1.mat4.fromValues(...delta.toArray()));
            this.deactivatePivotDragging();
            this.captureInitialWorldMatrices();
        }
        else {
            this.updateObjectMatrices();
        }
    }
    updateObjectsInternal() {
        if (__classPrivateFieldGet(this, _GumballTransform_pivotDragging, "f") === true)
            return;
        this.updateObjects();
    }
}
exports.GumballTransform = GumballTransform;
_GumballTransform_gumballTransformControls = new WeakMap(), _GumballTransform_systemInfo = new WeakMap(), _GumballTransform_transformationToolsPlaceholder = new WeakMap(), _GumballTransform_currentMatrix = new WeakMap(), _GumballTransform_enableRotation = new WeakMap(), _GumballTransform_enableScaling = new WeakMap(), _GumballTransform_enableTranslation = new WeakMap(), _GumballTransform_moving = new WeakMap(), _GumballTransform_pivotDragging = new WeakMap(), _GumballTransform_scale = new WeakMap(), _GumballTransform_space = new WeakMap();
//# sourceMappingURL=GumballTransform.js.map